export function statusColor(status: string, type: string) {
  switch (status) {
    case 'initial':
      if (type === 'bg') {
        return 'bg-warning-100';
      }
      return 'text-warning-300';
    case 'complete':
      if (type === 'bg') {
        return 'bg-success-100';
      }
      return ' text-success-300';
    case 'receivable':
      if (type === 'bg') {
        return 'bg-gray-100';
      }
      return ' text-gray-300';
    case 'confirmed':
      if (type === 'bg') {
        return 'bg-purple-100';
      }
      return ' text-info-300';
    case 'cancelled':
      if (type === 'bg') {
        return 'bg-red-100';
      }
      return 'text-red-300';
    case 'refunded':
      if (type === 'bg') {
        return 'bg-orange-100';
      }
      return 'text-orange-300';
    default:
      return '';
  }
}
